<template>
	<div class="cell small-12 medium-8 large-8 Overview_view">
		<div class="grid-x grid-margin-y grid-margin-x">
			<div class="cell small-12 medium-12 large-6">
				<ProfileBookingsOverviewCard />
			</div>
			<div class="cell small-12 medium-12 large-6">
				<ProfileGuestOverviewCard />
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import ProfileGuestOverviewCard from '../../components/molecules/ProfileGuestOverviewCard'
import ProfileBookingsOverviewCard from '../../components/molecules/ProfileBookingsOverviewCard'

export default {
	name: 'Overview_view',
	data() {
		return {}
	},
	components: {
		ProfileGuestOverviewCard,
		ProfileBookingsOverviewCard
	},
	methods: {
		logout() {
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(() => {
				store
					.dispatch('DELETE_TOKEN', { token: store.state.token.refreshToken })
					.then(() => {
						this.$router.push({ name: 'login' })
					})
			})
		}
	}
}
</script>

<style lang="scss">
.Overview_view {
	margin-top: 40px;
}
</style>
